var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7969 5L20.7969 9L18.7969 5M16.7969 5H14.7969V9H16.7969M14.7969 7H16.2969",
    stroke: "#9C4900",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 9V19C6.79688 19.5304 7.00759 20.0391 7.38266 20.4142C7.75773 20.7893 8.26644 21 8.79688 21H17.7969C18.3273 21 18.836 20.7893 19.2111 20.4142C19.5862 20.0391 19.7969 19.5304 19.7969 19V14M4.79688 5V3M8.79688 5V3M9.79688 5.6V7C9.79688 7.53043 9.58616 8.03914 9.21109 8.41421C8.83602 8.78929 8.32731 9 7.79688 9H5.79688C5.26644 9 4.75773 8.78929 4.38266 8.41421C4.00759 8.03914 3.79688 7.53043 3.79688 7V5.6C3.79687 5.44087 3.86009 5.28826 3.97261 5.17574C4.08513 5.06321 4.23775 5 4.39687 5H9.19687C9.356 5 9.50862 5.06321 9.62114 5.17574C9.73366 5.28826 9.79688 5.44087 9.79688 5.6Z",
    stroke: "#9C4900",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvLogo);
export default __webpack_public_path__ + "static/media/EV-logo.4c38880f26d0e715d94d235c33185b30.svg";
export { ForwardRef as ReactComponent };